import { createClient } from '@supabase/supabase-js';

// Directly use environment variables with validation
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables:', {
    url: supabaseUrl ? 'present' : 'missing',
    key: supabaseAnonKey ? 'present' : 'missing'
  });
  throw new Error('Missing Supabase environment variables');
}

console.log('Initializing Supabase client with URL:', supabaseUrl);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    flowType: 'implicit', // 이메일 확인 비활성화를 위해 implicit 사용
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'x-client-info': 'instachat-app'
    },
  },
  db: {
    schema: 'public',
  },
});

// 로그아웃 이벤트 감지 - 최적화된 버전
let redirectInProgress = false;

supabase.auth.onAuthStateChange((event) => {
  if (event === 'SIGNED_OUT' && !redirectInProgress) {
    console.warn('Auth state change:', event);
    redirectInProgress = true;

    // 페이지 리디렉션을 위한 타임아웃
    setTimeout(() => {
      console.log('Redirecting to auth page after signout');
      window.location.replace('/auth');
    }, 100);
  }
});